import React from 'react';
import { getDefaultTimezone } from '../utils/helpers/timezone';

export type TimezoneContextType = {
  timezone: string;
  setTimezone: (timezone: string) => void;
};

export const TimezoneContext = React.createContext<TimezoneContextType>({} as TimezoneContextType);

export const TimezoneContextProvider: React.FC = ({ children }) => {
  const [timezone, setTimezone] = React.useState(getDefaultTimezone());
  return <TimezoneContext.Provider value={{ timezone, setTimezone }}>{children}</TimezoneContext.Provider>;
};
